var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"w-full break-words"},[_c('div',{staticClass:"flex justify-between w-full"},[(_vm.rejectStatus)?_c('div',{staticClass:"w-full p-4"},[_c('ButtonGista',{staticClass:"w-full",attrs:{"type":"secondary","color":"success"},on:{"click":_vm.editProject}},[_vm._v(" Edit Project")])],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }